export default {
    SET_LIST_USER_SIGNATURE(state, payload) {
      let result = [];
      result = payload
      state.listUserSignature = result
    },
  }